// Utils
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { getUtmParams, segmentIdentify } from '../../analytics/segment';
import { updateScope } from '../../analytics/sentry';
import { updateIntercom } from '../../analytics/intercom';
import { getIntercomUserHash, updateIdentity } from '../../services/user.service';
import { obfuscateEmail } from '../../utils';

export const identifyUser = async (firebaseUser, user) => {
  try {
    const snapshots = user?.snapshots?.length > 0 ? user.snapshots : null;

    const traits: { [key: string]: number | boolean | string } = {
      addDateTime: user?.addDateTime,
      firstName: user?.names[0].first,
      obfsml: obfuscateEmail(firebaseUser?.email || ''),
      lastName: user?.names[0].last,
      state: user?.currentAddress.state,
      zipCode: user?.currentAddress.zipCode,
      homeValue: user?.homeValue,
      emailConsent: user?.emailConsent,
      smsConsent: user?.smsConsent,
      ownOrRent: user?.ownOrRent,
      rentMonthly: user?.rent,
      incomeMonthly: snapshots ? snapshots?.[snapshots.length - 1]?.value?.income?.monthly?.gross : null,
      expensesMonthly: snapshots ? snapshots?.[snapshots.length - 1]?.value?.expenses?.monthly : null,
    };

    if (user?.isPremium) {
      traits.isPremium = user.isPremium;
    }

    if (firebaseUser?.email) {
      traits.email = firebaseUser.email;
    }

    // Fire before the awaits below and outside any other integration's callback — this call
    // was previously nested inside LogRocket's getSessionURL and was deleted along with it.
    segmentIdentify({ firebaseUser, traits });

    const params = await getUtmParams();
    await updateIdentity({ params });

    updateScope({
      id: firebaseUser.uid,
      isPremium: user?.isPremium,
    });

    const { token } = await FirebaseAuthentication.getIdToken();
    const userHash = await getIntercomUserHash(firebaseUser.uid, token);
    if (userHash) {
      updateIntercom({
        userId: firebaseUser.uid,
        userHash,
        email: firebaseUser?.email ?? undefined,
        name: user?.names?.[0] ? `${user.names[0].first} ${user.names[0].last}` : undefined,
      });
    }
  } catch (e) {
    // Do nothing...
  }
};
